const planning = [
  {
    path: '/planning/deliveries',
    name: 'Deliveries',
    component: () => import('@/components/modules/planning/Deliveries'), // Deliveries,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
  {
    path: '/planning/requests',
    name: 'ReturnRequest',
    component: () => import('@/components/modules/planning/ReturnRequest'), // Return Request,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
];

export default planning;

